import { App } from './app';

// Redirect root path to /franqueabilidade
if (window.location.pathname === '/') {
  window.history.replaceState({}, '', '/franqueabilidade');
}

document.addEventListener('DOMContentLoaded', async () => {
  try {
    const app = new App();
    await app.init();
  } catch (error) {
    console.error('Error initializing app:', error);

    const appElement = document.getElementById('app');
    if (appElement) {
      appElement.innerHTML = `
        <div style="
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 100vh;
          padding: 20px;
          text-align: center;
        ">
          <h1 style="color: #ef4444; margin-bottom: 16px;">Erro ao carregar a aplicação</h1>
          <p style="color: #64748b; margin-bottom: 24px;">
            Ocorreu um erro ao inicializar o diagnóstico. Por favor, recarregue a página.
          </p>
          <button
            onclick="location.reload()"
            style="
              background: #2563eb;
              color: white;
              border: none;
              padding: 12px 24px;
              border-radius: 8px;
              cursor: pointer;
              font-size: 1rem;
            "
          >
            Recarregar
          </button>
        </div>
      `;
    }
  }
});
